module.exports = __webpack_public_path__ + "static/Lato-Regular-122dd68d69fe9587e062d20d9ff5de2a.ttf";